import { RENDERER_TYPES } from "../../../../enums";

const CLIENT_MEETINGS_COLUMNS = [
  {
    title: "Ambassador ",
    field: "firstName",
    dataType: "string",
    rendererType: RENDERER_TYPES.FULL_NAME_WITH_AVATAR,
    width: "20%",
  },
  {
    title: "Topic",
    field: "topics",
    dataType: "string",
    rendererType: RENDERER_TYPES.CHIP_LIST,
    width: "40%",
  },
  {
    title: "Date",
    field: "date",
    dataType: "string",
    rendererType: RENDERER_TYPES.FULL_DATE_FROM,
    width: "20%",
  },
  {
    title: "Status",
    field: "status",
    dataType: "string",
    rendererType: RENDERER_TYPES.MEETING_STATUS,
    width: "20%",
  },
];

const CLIENT_MEETINGS_ROWS = [
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: true,
    isRejected: false,
  },
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: true,
    isRejected: false,
  },
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: true,
    isRejected: false,
  },
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: true,
    isRejected: false,
  },
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: false,
    isRejected: false,
  },
  {
    firstName: "Nixie",
    lastName: "Sailor",
    topic: "Paychex",
    date: "August 2, 2022 09:30 AM",
    isCompleted: false,
    isRejected: false,
  },
];

export { CLIENT_MEETINGS_COLUMNS, CLIENT_MEETINGS_ROWS };
